import { httpClient } from "@/lib/http-client";
import { API_ROUTES } from "@/lib/consts/api";

export type SessionTokenProbeResult = 'alive' | 'dead' | 'unknown';

// Probe the gateway with an explicit bearer (never the httpClient default
// header — it may not be armed yet on the login page). The http client
// resolves 401/403 with `data: undefined` instead of throwing.
//
// `dead`  — gateway rejected the token; safe to purge client storage.
// `alive` — gateway accepted the token.
// `unknown` — network/5xx/other; do NOT purge (v1→v2 migration blips).
export const probeSessionToken = async (
    sessionToken: string,
): Promise<SessionTokenProbeResult> => {
    try {
        const response = await httpClient.post(API_ROUTES.KEEP_ALIVE, undefined, {
            headers: { Authorization: `Bearer ${sessionToken}` },
        });
        if (response.status >= 200 && response.status < 300) {
            return 'alive';
        }
        if (response.status === 401 || response.status === 403) {
            return 'dead';
        }
        return 'unknown';
    } catch {
        return 'unknown';
    }
};

export const isSessionTokenAlive = async (sessionToken: string): Promise<boolean> => {
    return (await probeSessionToken(sessionToken)) === 'alive';
};
